export const subCategories: string[] = [
  'Matemática',
  'Lengua',
  'Ciencias Sociales',
  'Ciencias Naturales',
  'Ingles',
];
